import React, { Component } from "react";
import axios from "axios";
import * as appConst from "../../../Common/constants";
import ReceiptEntry from "./Report.DisposeEntry";

class ReceiptMultiple extends Component {
  constructor(props) {
    super(props);

    this.state = {
      _id: "",
      name: "",
      date: "",
      desc: "",
      qty: 0,
      receipts: [],
      receipt: ""
    };
  }

  componentDidMount() {
    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
          
          "/equipment/disposeDetails",
        this.props.data
      )
      .then(response => {
        if (this.props.data.count === 1) {
          var obj = response.data;
          var arr = obj.txnDate.split("-");

          const data = {
            _id: obj._id,
            name: obj.name,
            date: arr[2].substring(0, 2) + "-" + arr[1] + "-" + arr[0],
            desc: obj.desc,
            qty: obj.qty
          };
          this.setState({ receipt: data });
        } else {
          response.data.map(obj => {
            var arr = obj.txnDate.split("-");
            const data = {
              _id: obj._id,
              name: obj.name,
              date: arr[2].substring(0, 2) + "-" + arr[1] + "-" + arr[0],
              desc: obj.desc,
              qty: obj.qty
            };
            this.setState(previousState => ({
              receipts: [...previousState.receipts, data]
            }));
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  render() {
    return <div className="p-5">{this.RenderReceipt()}</div>;
  }

  RenderReceipt() {
    if (this.props.data.count === 1) {
      return (
        <ReceiptEntry key={this.state.receipt._id} data={this.state.receipt} />
      );
    } else {
      return this.state.receipts.map(obj => {
        return <ReceiptEntry key={obj._id} data={obj} />;
      });
    }
  }
}

export default ReceiptMultiple;
